"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const flatten_1 = tslib_1.__importDefault(require("lodash/flatten"));
const getKeyFromState_1 = require("../helpers/getKeyFromState");
const isEmptyObject_1 = tslib_1.__importDefault(require("../helpers/isEmptyObject"));
const entity_1 = require("../type/entity");
const assignmentCardZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/assignmentCardZeroState"));
const assignmentQuestionZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/assignmentQuestionZeroState"));
const cardQuestionForReviewZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/cardQuestionForReviewZeroState"));
const learningCardZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/learningCardZeroState"));
const peerReviewCardZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/peerReviewCardZeroState"));
const sectionZeroState_1 = tslib_1.__importDefault(require("./nodeZeroState/sectionZeroState"));
function nonExistingNonRootZeroStatesOfOffer(content, user, existingStates) {
    const existingStatesDictionary = {};
    existingStates.forEach((existingState) => (existingStatesDictionary[getKeyFromState_1.getKeyFromState(existingState)] = 1));
    const states = flatten_1.default((content.children || []).map((childContent) => nonExistingNonRootZeroStatesOfOffer(childContent, user, existingStates)));
    const contentType = content.offerType;
    let state = {};
    if (!existingStatesDictionary[getKeyFromState_1.getKeyFromContentAndUser(user, content)]) {
        switch (contentType) {
            case entity_1.ContentType.LEARNING_CARD:
                state = learningCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.ASSIGNMENT_CARD:
                state = assignmentCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CARD_QUESTION:
                state = assignmentQuestionZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.PEER_REVIEW_CARD:
                state = peerReviewCardZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.CARD_QUESTION_FOR_REVIEW:
                state = cardQuestionForReviewZeroState_1.default(content, user);
                break;
            case entity_1.ContentType.SECTION:
                state = sectionZeroState_1.default(content, user);
                break;
            default:
                break;
        }
    }
    if (!isEmptyObject_1.default(state)) {
        states.push(state);
    }
    return states;
}
exports.nonExistingNonRootZeroStatesOfOffer = nonExistingNonRootZeroStatesOfOffer;
//# sourceMappingURL=nonExistingNonRootZeroStatesOfOffer.js.map